var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 291"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 242",
    style: {
      fill: "none"
    },
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 290"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 175",
    d: "M12.017 1.576h-.534v-.81a.766.766 0 1 0-1.532 0v.81H5.284v-.81a.766.766 0 0 0-1.532 0v.81h-.534A3.221 3.221 0 0 0 0 4.794v7.988A3.221 3.221 0 0 0 3.218 16h8.8a3.221 3.221 0 0 0 3.218-3.218V4.794a3.221 3.221 0 0 0-3.218-3.218m-8.8 1.532h8.8A1.688 1.688 0 0 1 13.7 4.794v.974H1.532v-.974a1.688 1.688 0 0 1 1.686-1.685m8.8 11.359h-8.8a1.688 1.688 0 0 1-1.686-1.686V7.3H13.7v5.482a1.688 1.688 0 0 1-1.686 1.686",
    transform: "translate(.383)",
    style: {
      fill: "#1a1818"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 289"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 176",
    d: "M12 28.145h-.41a.766.766 0 0 0 0 1.532H12a.766.766 0 1 0 0-1.532",
    transform: "translate(-7.123 -19.52)",
    style: {
      fill: "#1a1818"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 177",
    d: "M22.862 28.145h-.409a.766.766 0 0 0 0 1.532h.409a.766.766 0 0 0 0-1.532",
    transform: "translate(-14.657 -19.52)",
    style: {
      fill: "#1a1818"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 178",
    d: "M33.727 28.145h-.409a.766.766 0 0 0 0 1.532h.409a.766.766 0 1 0 0-1.532",
    transform: "translate(-22.192 -19.52)",
    style: {
      fill: "#1a1818"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 179",
    d: "M12 37.241h-.41a.766.766 0 0 0 0 1.532H12a.766.766 0 0 0 0-1.532",
    transform: "translate(-7.123 -25.827)",
    style: {
      fill: "#1a1818"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 180",
    d: "M22.862 37.241h-.409a.766.766 0 0 0 0 1.532h.409a.766.766 0 0 0 0-1.532",
    transform: "translate(-14.657 -25.827)",
    style: {
      fill: "#1a1818"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 181",
    d: "M33.727 37.241h-.409a.766.766 0 0 0 0 1.532h.409a.766.766 0 0 0 0-1.532",
    transform: "translate(-22.192 -25.827)",
    style: {
      fill: "#1a1818"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendar);
export default __webpack_public_path__ + "static/media/ic-calendar.1b882402d314cf552eb1625343e6ac9d.svg";
export { ForwardRef as ReactComponent };